export class SalaryModel {

  uid: string;
  activityUid: string;
  concept: string;
  date: Date;
  salaryBrut: number;
  salaryInKind: number;
  irpf: number;
  segSocialWorker: number;
  otherDeductions: number;
  advancePayments: number;
  segSocialCompany: number;
  salaryNet: number;
  paided: Date;
  typePay: string;
  typePayBankAccount: string;
  fiscalYear: number;
  accounted: string;
  employee_Id: number;
  employee_name: string;
  irpfnKind: number;
  paidedSalaries: string; // pago Nominas
  paidedSegSo: string; // Pago seguridad social
  salariesIdRelatedForActivities: number;
  exemptSalary: number;
  exemptSalaryInKind: number;
  paymentsForIncapacityForWork: number;
  personalIncomeTaxOnPaymentsForIncapacityForWork: number;
  projectUid?: string;
  expenseProjectTypeUid?: string;

  // Clasificador de gastos (subpartida, siempre bajo "1. Gastos de personal") - solo asociaciones/fundaciones
  clasificadorSubpartida?: string;

  constructor() { }
}
